function toggleSelectElements() {
  var names = new Array("select", "object", "embed");
  for(var i=0; i<names.length; i++) {
    var els = document.getElementsByTagName(names[i]);
    for(var j=0; j<els.length; j++) {
      if(els[j].getAttribute("prevVisibilityStyle") != null) {
        els[j].style.visibility = els[j].getAttribute("prevVisibilityStyle");
        els[j].removeAttribute("prevVisibilityStyle")
      } else {
        els[j].setAttribute("prevVisibilityStyle", els[j].style.visibility);
        els[j].style.visibility = "hidden";
      }
    }
  }
}

function getBodyRect() {
  var width = document.body.scrollWidth;
  var height = document.body.scrollHeight;
  var scrollLeft = document.body.scrollLeft;
  var scrollTop = document.body.scrollTop;
  var clientWidth = document.body.clientWidth;
  var clientHeight = document.body.clientHeight;

  if(document.documentElement && document.documentElement.scrollWidth) {
    width = Math.max(width, document.documentElement.scrollWidth);
    height = Math.max(height, document.documentElement.scrollHeight);
    scrollLeft = Math.max(scrollLeft, document.documentElement.scrollLeft);
    scrollTop = Math.max(scrollTop, document.documentElement.scrollTop);
    clientWidth = Math.min(clientWidth, document.documentElement.clientWidth);
    clientHeight = Math.min(clientHeight, document.documentElement.clientHeight);
  }
  return {
    width: width,
    height: height,
    scrollLeft: scrollLeft,
    scrollTop: scrollTop,
    clientWidth: clientWidth,
    clientHeight: clientHeight
  };
}

function initBodyShader() {
  var el = document.createElement("DIV");
  el.className = "bodyShader";
  el.id = "bodyShader";
  el.onclick = new Function("return false;");
  document.body.appendChild(el);
  try {
    if(el.filters) {
      var backgroundPath = el.currentStyle.backgroundImage.replace('url("', '').replace('")', '');
      el.runtimeStyle.backgroundImage = "none";
      el.style.filter = 'progid:DXImageTransform.Microsoft.AlphaImageLoader(src="' + backgroundPath + '", sizingMethod="scale");';
    }
  } catch(e) {
  }
}

function shadeBody() {
  toggleSelectElements();
  var el = document.getElementById("bodyShader");
  el.style.width = "100%";
  el.style.height = "100%";
  el.style.display = "block";
  window.prevonresize = window.onresize;
  window.onresize = function() {
    var rect = getBodyRect();
    el.style.width = rect.width + "px";
    el.style.height = rect.height + "px";
  }
  window.onresize();
}

function unshadeBody() {
  toggleSelectElements();
  var el = document.getElementById("bodyShader");
  el.style.display = "none";
  window.onresize = window.prevonresize;
  window.prevonresize = null;
}

/*Upload Handler >>>*/
function UploadHandler(form) {
  jQuery(form).submit(showStatus);
  var form = form;
  var uploadId = "";
  var formSubmited = false;

  if(document.getElementById("formUploadStatus") == null) {
    var el = document.createElement("SPAN");
    el.id = "formUploadStatus";
    el.className = "uploadStatus";
    el.style.display = "none";
    el.innerHTML =
    "<table style=\"width:100%;\">" +
    "<tr><td class='progressbar'><div style='width:0' id='formUploadStatus_progressbar'></div></td></tr>" +
    "<tr>" +
    " <td>" +
    "   <table style=\"width:100%;\">" +
    "   <tr>" +
    "     <td align='left' id='formUploadStatus_uploadSpeed'>0 Kb/s</td>" +
    "     <td align='right' id='formUploadStatus_uploadPercent'>0%</td>" +
    "   </tr>" +
    "   </table>" +
    " </td>" +
    "</tr>" +
    "<tr>" +
    " <td height='20'>&nbsp;</td>" +
    "</tr>" +
    "<tr>" +
    " <td>" +
    "   <table class=\"info\" style=\"width:100%;\">" +
    "   <tr class='row1'><td width='40%'>&nbsp;</td><td width='30%' class='header'>Size</td><td class='header'>Time</td></tr>" +
    "   <tr class='row2'><td class='header'>"+I18n.t("Total")+"</td><td id='formUploadStatus_totalBytes'>0 Kb</td><td id='formUploadStatus_totalTime'>00:00:00</td></tr>" +
    "   <tr class='row1'><td class='header'>"+I18n.t("Completed")+"</td><td id='formUploadStatus_uploadedBytes'>0 Kb</td><td id='formUploadStatus_uploadTime'>00:00:00</td></tr>" +
    "   <tr class='row2'><td class='header'>"+I18n.t("Remaining")+"</td><td id='formUploadStatus_remainingBytes'>0 Kb</td><td id='formUploadStatus_remainingTime'>00:00:00</td></tr>" +
    "   </table>" +
    " </td>" +
    "</tr>" +
    "</table>";
    document.body.appendChild(el);
  }

  function showStatus() {
    var now = new Date();
    uploadId = now.getFullYear() + '' + now.getMonth() + '' + now.getDate() + '' +
               now.getHours() + '' + now.getMinutes() + '' + now.getSeconds() + '' +
               now.getMilliseconds();
    var action = form.action.replace(/[?&]upload_status_id=[^&]+/, "");
    action = action + (action.indexOf("?") == -1 ? "?" : "&") + "upload_status_id=" + uploadId;
    form.action = action;

    shadeBody();
    var el = document.getElementById("formUploadStatus");
    el.style.visibility = "hidden";
    var rect = getBodyRect();
    el.style.display = "";
    el.style.top = Math.floor(rect.scrollTop + (rect.clientHeight - el.offsetHeight) / 2) + "px";
    el.style.left = Math.floor(rect.scrollLeft + (rect.clientWidth - el.offsetWidth) / 2) + "px";
    el.style.visibility = "";
    formSubmited = false;
    updateStatus({aborted: 0, complete: 0, totalBytes: 0, uploadedBytes: 0, uploadTime: 0});
    return false;
  }

  function updateStatus(status) {
    var el;
    if(status.aborted || status.complete) {
      unshadeBody();
      el = document.getElementById("formUploadStatus");
      el.style.display = "none";
      return;
    }
    el = document.getElementById("formUploadStatus_progressbar");
    el.style.width = Math.floor(el.offsetParent.offsetWidth * status.uploadedBytes / (status.totalBytes == 0 ? 1 : status.totalBytes)) + "px";
    el = document.getElementById("formUploadStatus_uploadSpeed");
    if(status.uploadTime != 0) el.innerHTML = formatSize(status.uploadedBytes / status.uploadTime) + "/s";
    el = document.getElementById("formUploadStatus_uploadPercent");
    if(status.totalBytes != 0) el.innerHTML = Math.floor(status.uploadedBytes * 100 / status.totalBytes) + "%";
    el = document.getElementById("formUploadStatus_totalBytes");
    el.innerHTML = formatSize(status.totalBytes);
    el = document.getElementById("formUploadStatus_uploadedBytes");
    el.innerHTML = formatSize(status.uploadedBytes);
    el = document.getElementById("formUploadStatus_remainingBytes");
    el.innerHTML = formatSize(status.totalBytes - status.uploadedBytes);
    var totalTime = Math.floor(status.uploadedBytes == 0 ? 0 : (status.uploadTime * status.totalBytes / status.uploadedBytes));
    el = document.getElementById("formUploadStatus_totalTime");
    el.innerHTML = formatTime(totalTime);
    el = document.getElementById("formUploadStatus_uploadTime");
    el.innerHTML = formatTime(status.uploadTime);
    el = document.getElementById("formUploadStatus_remainingTime");
    el.innerHTML = formatTime(totalTime - status.uploadTime);
    if(formSubmited) {
      window.setTimeout(queryStatus, 500);
    } else {
      queryStatus();
    }
  }

  function queryStatus() {
    jQuery.getJSON(Config.exec + "/uploadstatus",
      {"upload_status_id": uploadId, "JsHttpRequest": (new Date()).getTime()},
      function(data) {
        eval(data.js);
        if(!formSubmited) {
          formSubmited = true;
          updateStatus(status);
          form.submit();
        } else {
          updateStatus(status);
        }
    });
  }

  function formatSize(bytes) {
    bytes = Math.floor(bytes);
    var kb = new Number(bytes / 1024).toFixed(2);
    var mb = new Number(bytes / (1024 * 1024)).toFixed(2);
    if(mb >= 1) {
      return mb + " Mb";
    } else if(kb >= 1) {
      return kb + " Kb";
    } else {
      return bytes + " b";
    }
  }

  function formatTime(seconds) {
    if(seconds < 0) return "00:00:00";
    var minutes = Math.floor(seconds / 60);
    minutes = minutes % 60;
    var hours = Math.floor(seconds / (60 * 60));
    hours = hours % 60;
    seconds = seconds % 60;
    return (hours > 9 ? hours : "0" + hours) + ":" + (minutes > 9 ? minutes : "0" + minutes) + ":" + (seconds > 9 ? seconds : "0" + seconds);
  }
}

/*<<< Upload Handler*/
_onload_functions[_onload_functions.length] = function() {
  initBodyShader();
  var forms = jQuery("form.upload");
  for(var i=0; i<forms.length; i++) {
    new UploadHandler(forms[i]);
  }
};